import Vue from "vue";
import Vuex from "vuex";
import Hospital from "./Modules/Hospital";
import Animal from "./Modules/Animal";
import History from "./Modules/History";
import Species from "./Modules/Species";
import Address from "./Modules/Address";
import Gender from "./Modules/Gender";
import ContactType from "./Modules/ContactType.js";
import Test from "./Modules/Test";
import createPersistedState from "vuex-persistedstate";
import Order from "./Modules/Order";
import Auth from "./Modules/Auth";
import CreditType from "./Modules/CreditType";
import CustomerType from "./Modules/CustomerType";
import Direction from "./Modules/Direction";
import UrgencyHospitalType from "./Modules/UrgencyHospitalType";
import Result from "./Modules/Result";
import Status from "./Modules/Status";
import Corporation from "./Modules/Corporation"
import RejectReason from "./Modules/RejectReason"
import CancelReason from "./Modules/CancelReason"
import SharedMethod from "./Modules/SharedMethod";
import Account from "./Modules/Account"
import Item from "./Modules/Item"
import Settings from "./Modules/Settings"
import QualityControl from  "./Modules/QualityControl"
import Breed from './Modules/Breed'
// window.localStorage.removeItem("vuex");
Vue.use(Vuex);

const modules = {
    History: History,
    Hospital: Hospital,
    Animal: Animal,
    Species: Species,
    Address: Address,
    Gender: Gender,
    ContactType: ContactType,
    Test: Test,
    Order: Order,
    Auth: Auth,
    CreditType: CreditType,
    CustomerType: CustomerType,
    Direction: Direction,
    UrgencyHospitalType: UrgencyHospitalType,
    Result: Result,
    Status: Status,
    Corporation: Corporation,
    RejectReason: RejectReason,
    CancelReason: CancelReason,
    SharedMethod: SharedMethod,
    Account: Account,
    Item: Item,
    Breed,
    QualityControl: QualityControl,
    Settings,
};

export default new Vuex.Store({
    modules,
    state: {
      routeName: '',
      isLoading: '',
        isEditing: false
    },
    plugins: [createPersistedState({
			storage: window.sessionStorage
		})]
});
